<script setup lang="ts">
import FlipbookSamudkoy from './base/FlipbookSamudkoy.vue'
import { useLanguage } from '@/core/composables/useLanguage'

const { currentLang } = useLanguage()
</script>

<template>
  <transition name="fade" mode="out-in">
    <FlipbookSamudkoy v-show="currentLang == 'th'" lang="th" />
  </transition>
  <transition name="fade" mode="out-in">
    <FlipbookSamudkoy v-show="currentLang == 'en'" lang="en" />
  </transition>
</template>

<style scoped></style>
